import EditSettingModal from './EditSettingModal';

export default EditSettingModal;
